export var EField;
(function (EField) {
    EField["Header"] = "_header";
    EField["Iban"] = "iban";
    EField["OwnerName"] = "ownerName";
})(EField || (EField = {}));
